import { baseConstants } from '..';


export const scorecardReducers = (state = {}, action) => {
    let entityValues
    switch (action.type) {
        case (baseConstants.GET_SCORE_CARDS_REQUEST + '_' + action.resourceName):
            return {
                ...state,
                loading: true,
                entityName: action.resourceName
            }
        case (baseConstants.GET_SCORE_CARDS_SUCCESS + '_' + action.resourceName):
            let returnObj = 
            {
                ...state,
                loading: false,
                entityName: action.resourceName
            }
            if(action.targetProp) returnObj[action.targetProp] = action.item 
            else returnObj.data = action.item
            returnObj.inputs = action.data && action.data.inputs
            return returnObj
        case (baseConstants.GET_SCORE_CARDS_FAILURE + '_' + action.resourceName):
            return {
                ...state,
                loading: false,
                entityName: action.resourceName
            }
        
        case (baseConstants.LOADER_FALSE + '_' + action.resourceName):
            return {
                ...state,
                loading: false,
                entityName: action.resourceName
            }
        
        default:
            return state
    }
}
// }
